<template>
  <div v-if="isShowContent">
    <div class="ccui-app-container-detail2">
      <div class="ccui-app-container-detail-body">
        <p class="top-tips">
          注意：我司合同采用线上电子签约的模式，目前是与E签宝平台进行合作。请在以下信息填写：电子签约联系人及联系电话，确保与后续E签宝平台注册认证信息一致，感谢配合！E签宝平台企业实名认证流程请参考：<a href="https://help.esign.cn/detail?id=pyswk8&nameSpace=cs3-dept%2Fexboae" target="_blank" class="path">https://help.esign.cn/detail?id=pyswk8&nameSpace=cs3-dept%2Fexboae。</a>
        </p>
        <el-form
          ref="form"
          :model="form"
          :rules="rules"
          label-width="160px"
          class="ccui-form"
        >
          <div class="ccui-top-title">电子签信息</div>
          <el-form-item label="电子签约联系人：" prop="contractAUser">
            <el-input
              maxlength="200"
              clearable
              @blur="allStrTrim('contractAUser')"
              v-model="form.contractAUser"
              class="input-long"
              placeholder="请输入电子签约联系人"
            />
          </el-form-item>
          <el-form-item label="电子签约联系电话：" prop="contractATell">
            <el-input
              maxlength="200"
              clearable
              @input="regNumber('contractATell')"
              v-model="form.contractATell"
              class="input-long"
              placeholder="请输入电子签约联系电话"
            />
          </el-form-item>
          <div class="ccui-top-title">税务信息</div>
          <el-form-item label="甲方全称：">
            {{ form.shopName }}
          </el-form-item>
          <el-form-item label="纳税人身份：" prop="taxpayerType">
            <el-select
              clearable
              v-model.trim="form.taxpayerType"
              class="input-long"
              placeholder="请选择纳税人身份"
            >
              <el-option
                v-for="(item, idx) in taxpayerTypeList"
                :label="item.label"
                :value="item.value"
                :key="idx"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="纳税人识别号：" prop="taxNumber">
            <el-input
              maxlength="200"
              clearable
              @blur="allStrTrim('taxNumber')"
              v-model="form.taxNumber"
              class="input-long"
              placeholder="请输入纳税人识别号"
            />
          </el-form-item>
          <el-form-item label="注册地址：" prop="registeredAddress">
            <el-input
              clearable
              maxlength="200"
              v-model.trim="form.registeredAddress"
              class="input-long"
              placeholder="请输入注册地址"
            />
          </el-form-item>
          <el-form-item label="注册电话：" prop="registeredPhone">
            <el-input
              clearable
              maxlength="11"
              v-model.trim="form.registeredPhone"
              @input="regNumber('registeredPhone')"
              class="input-long"
              placeholder="请输入注册电话"
            />
          </el-form-item>
          <el-form-item label="开户银行：" prop="accountBank">
            <el-input
              clearable
              maxlength="80"
              v-model.trim="form.accountBank"
              class="input-long"
              placeholder="请输入开户银行"
            />
          </el-form-item>
          <el-form-item label="银行账号：" prop="accountNumber">
            <el-input
              clearable
              maxlength="80"
              v-model.trim="form.accountNumber"
              @input="regNumber('accountNumber')"
              class="input-long"
              placeholder="请输入银行账号"
            />
          </el-form-item>
          <div class="ccui-top-title">对账结算授权人</div>
          <el-form-item label="姓名：" prop="authorizer">
            <el-input
              maxlength="200"
              clearable
              @blur="allStrTrim('authorizer')"
              v-model="form.authorizer"
              class="input-long"
              placeholder="请输入姓名"
            />
          </el-form-item>
          <el-form-item label="联系电话：" prop="authorizerPhone">
            <el-input
              maxlength="11"
              clearable
              @input="regNumber('authorizerPhone')"
              v-model="form.authorizerPhone"
              class="input-long"
              placeholder="请输入联系电话"
            />
          </el-form-item>
          <el-form-item label="联系邮箱：" prop="authorizerEmail">
            <el-input
              maxlength="200"
              clearable
              @blur="allStrTrim('authorizerEmail')"
              v-model="form.authorizerEmail"
              class="input-long"
              placeholder="请输入联系邮箱"
            />
          </el-form-item>
        </el-form>
        <div class="goToShop">
          <div class="goToShopDetails">
            <el-checkbox v-model="checked" />
            我已查看并同意服务协议中所约定的内容。查看
            <a class="shopagreementcss" target="_blank" :href="downFileUrl" download="中交云采平台技术服务协议.doc">
              《中交云采平台技术服务协议》
            </a>
          </div>
        </div>
        <div class="footer-step-lyp">
          <el-button :loading="btnLoading" @click="lastStep" type="primary" style="width: 240px; font-weight: 600;height:40px">上一步</el-button>
          <el-button :loading="btnLoading" @click="submit" type="primary" style="width: 240px; font-weight: 600;height:40px">提交</el-button>
        </div>
        <div style="height: 20px"></div>
      </div>
    </div>
  </div>
</template>

<script>
import validators from "@/utils/validators";
import { addAgreementPreview, addShopByThreeParty } from "@/api/apply-shop-edit.js";
export default {
  name: "contractBusinessInfo",
  components: {},
  data() {
    return {
      btnLoading: false,
      checked: false,
      form: {
        shopName: "",
        contractAUser: "",
        contractATell: "",
        taxpayerType: "",
        taxNumber: "",
        registeredAddress: "",
        registeredPhone: "",
        accountBank: "",
        accountNumber: "",
        authorizer: "",
        authorizerPhone: "",
        authorizerEmail: "",
      },
      rules: {
        contractAUser: [
          { required: true, message: "请输入电子签约联系人", trigger: "blur" },
        ],
        contractATell: [
          { required: true, message: "请输入电子签约联系电话", trigger: "blur" },
          {
            validator: validators.mobile,
            message: "请输入正确格式的电话",
            trigger: "blur",
          },
        ],
        taxpayerType: [
          { required: true, message: "请选择纳税人身份", trigger: "change" },
        ],
        taxNumber: [
          { required: true, message: "请输入纳税人识别号", trigger: "blur" },
          {
            pattern: /^[0-9A-HJ-NPQRTUWXY]*$/,
            message: "请输入正确的纳税人识别号",
            trigger: "blur",
          },
        ],
        registeredAddress: [
          { required: true, message: "请输入注册地址", trigger: "blur" },
        ],
        registeredPhone: [
          { required: true, message: "请输入注册电话", trigger: "blur" },
          {
            validator: validators.mobileTel,
            message: "请输入正确格式的电话",
            trigger: "blur",
          },
        ],
        accountBank: [
          { required: true, message: "请输入开户银行", trigger: "blur" },
        ],
        accountNumber: [
          { required: true, message: "请输入银行账号", trigger: "blur" },
        ],
        authorizer: [
          { required: true, message: "请输入姓名", trigger: "blur" },
        ],
        authorizerPhone: [
          { required: true, message: "请输入联系电话", trigger: "blur" },
          {
            validator: validators.mobile,
            message: "请输入正确格式的电话",
            trigger: "blur",
          },
        ],
        authorizerEmail: [
          { required: true, message: "请输入联系邮箱", trigger: "blur" },
          {
            required: false,
            pattern: /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/,
            message: "只支持输入邮箱格式",
            trigger: "blur"
          }
        ],
      },
      taxpayerTypeList: [
        {value: '1', label: "小规模纳税人"},
        {value: '2', label: "营业纳税人"},
        {value: '3', label: "一般纳税人"},
      ],
      isShowContent: true,
      messageHeight: null,
    };
  },
  computed: {
    reload() {
      return this.$store.state.app.reload;
    },
    downFileUrl() {
      const url = this.$addUrlPerFix(process.env.VUE_APP_FILE_AGREEMENT_FILE)
      const { hostname } = new URL(url)
      let uploadId = ''
      if (hostname.includes('dev') || hostname.includes('test')) {
        uploadId = '10006119598'
      } else if (hostname.includes('uat')) {
        uploadId = '10006152233'
      } else {
        uploadId = '10077761112'
      }
      return this.$addUrlPerFix(process.env.VUE_APP_FILE_AGREEMENT_FILE) + `?uploadId=${uploadId}`
    },
  },
  mounted() {
    this.mountedFn();
  },
  destroyed() {
    this.deleteLoad();
  },
  beforeRouteLeave(to, from, next) {
    this.deleteLoad();
    next();
  },
  activated() {},
  methods: {
    // 调用提交接口
    addShopByThreeParty(submitParams) {
      addShopByThreeParty(submitParams)
        .then((res) => {
          this.btnLoading = false;
          if (res.data.code === "0") {
            this.$store.state.app.resultInfo = {};
            this.$store.state.app.userRegisterInfo.shopId = res.data.data;
            this.$router.replace(
              "/business-open-shop/approval/" +
                this.$crypto.Encrypt(res.data.data + "") +
                "/" +
                this.$crypto.Encrypt("1")
            );
            this.$store.dispatch("businessOpenShopSetStep", 5);
          }else {
            this.$message({
              showClose: true,
              type: "error",
              message: res.data.message,
              ccuiCustom: true,
            });
          }
        })
        .catch((errRes) => {
          //报错状态码
          console.log("捕获错误码" + errRes);
          this.btnLoading = false;
        });
    },
    allStrTrim(key) {
      this.form[key] = this.form[key].trim();
    },
    regNumber(name) {
      this.form[name] = this.form[name].replace(/[^\d.]/g, "");
    },
    regSpace(name) {
      this.form[name] = this.form[name].replace(/\s+/g, "");
    },
    //获取浏览器视口高度
    getBrowserHeight() {
      this.messageHeight = (window.innerHeight - 40) / 2;
    },
    mountedFn() {
      this.getBrowserHeight();
      this.$store.commit("ADD_CACHED_VIEW", { name: "contractBusinessInfo" });
      let getBusinessName = sessionStorage.getItem("businessName");
      if (this.reload) {
        this.deleteLoad();
        this.$router.replace("/business-open-shop/ready-data");
        return false;
      }
      this.$store.commit("RELOAD_SET", true);
      this.form.shopName = getBusinessName;
      // 进来编辑的时候，已经查询过合同信息并存在sessionStorage中了
      if (sessionStorage.getItem("contractCommonShopBO")) {
        const contractCommonShopBO = JSON.parse(sessionStorage.getItem("contractCommonShopBO"))
        this.copyObj(this.form, contractCommonShopBO);
        this.form.contractId = contractCommonShopBO.contractId
        sessionStorage.removeItem("contractCommonShopBO");
      }
      window.onbeforeunload = this.onbeforeunload;
    },
    copyObj(target, obj) {
      for (let key in obj) {
        for (let targetKey in target) {
          if (key === targetKey) {
            target[targetKey] = obj[key];
          }
        }
      }
    },
    deleteLoad() {
      window.removeEventListener("beforeunload", (e) => this.onbeforeunload(e));
      //window.onbeforeunload = null
    },
    onbeforeunload(e) {
      e = e || window.event;
      // 兼容IE8和Firefox 4之前的版本
      if (e) {
        e.returnValue = "关闭提示";
      }
      // Chrome, Safari, Firefox 4+, Opera 12+ , IE 9+
      return "关闭提示";
    },
    async toViewAgreement() {
      // TODO：《中交云采平台技术服务协议》点击事件
      const res = await addAgreementPreview({});
      console.log("🚀 ~ toViewAgreement ~ res:", res)
      // window.open(this.downFileUrl, "_blank");
    },
    // 上一步
    lastStep() {
      this.$router.go(-1);
      this.$store.dispatch("businessOpenShopSetStep", 3);
    },
    // 下一步
    submit() {
      if (!this.checked) {
        this.$message({
          showClose: true,
          type: "warning",
          message: '请勾选协议',
          ccuiCustom: true,
          offset: this.messageHeight
        });
        return
      }
      this.$refs["form"].validate((flag) => {
        if (!flag) return
        this.btnLoading = true
        const { contactName, phone, authCode } = this.$store.state.app.userRegisterInfo
        const params = {
          ...this.$store.state.app.tempStoreInfo,
          contactName,
          phone,
          authCode,
          shopSource: 1,
          contractCommonShopBO: this.form
        }
        this.addShopByThreeParty(params);
      });
    },
  },
};
</script>

<style scoped lang="scss">
.explain {
  display: inline-block;
  line-height: 16px;
  position: absolute;
  margin-left: 20px;
  color: #9b9b9b;
}
/deep/ .input-long {
  width: 410px;
}
/deep/ .checkClass {
  input::-webkit-input-placeholder {
    /* WebKit, Blink, Edge */
    color: #4a4a4a;
  }

  input:-moz-placeholder {
    /* Mozilla Firefox 4 to 18 */
    color: #4a4a4a;
    opacity: 1;
  }

  input::-moz-placeholder {
    /* Mozilla Firefox 19+ */
    color: #4a4a4a;
    opacity: 1;
  }

  input:-ms-input-placeholder {
    /* Internet Explorer 10-11 */
    color: #4a4a4a;
  }
}
.ccui-app-container-detail2 {
  margin: 20px 0px 20px;
  padding: 21px 0px 0px;
  .top-tips {
    color: #f5a24d;
    font-size: 14px;
    line-height: 26px;
    padding-bottom: 25px;
    .path {
      color: #0089EF;
    }
  }
  .ccui-form {
    margin-top: 0;
    .ccui-top-title {
      margin-bottom: 10px;
    }
  }

  .goToShop {
    height: 18px;
    margin: 20px 0;
    font-family: PingFang-SC-Medium;
    font-size: 13px;
    color: #9b9b9b;
    line-height: 18px;
    .goToShopDetails {
      height: 100%;
      margin: 0 auto;
      text-align: center;
      .el-checkbox {
        margin-right: 10px;
      }
    }
    .shopagreementcss {
      color: #f50b25;
    }
  }
  .footer-step-lyp {
    font-family: PingFangSC-Semibold;
  }
}

.icon-delete {
  margin-top: 10px;
  margin-left: -33px;
  position: absolute;
  display: none;
  color: #909399;
  cursor: pointer;
}
/deep/ .el-cascader:hover + .icon-delete {
  display: inline-block;
  color: #909399;
}
.icon-delete:hover {
  display: inline-block;
  color: #909399;
}
</style>
